__turbopack_context__.v({
  "markdown-body": "ZBuKcq_markdown-body",
});
